"use client";

import { CirclePlay as PlayCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Showreel() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="799" id="the-oddhatter-showreel" className="relative w-full h-screen min-h-[700px] overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 w-full h-full">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718611/img/oddhatter_cinematic_performance.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718611/img/oddhatter_cinematic_performance.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718611/img/oddhatter_cinematic_performance.png-wvc-sizes" alt="Oddhatter showreel cinematic performance visual" loading="eager" decoding="async" className="w-full h-full object-cover scale-105 animate-[slow-zoom_20s_ease-in-out_infinite_alternate]" />
      </div>

      {}
      <div className="absolute inset-0 w-full h-full pointer-events-none" style={{
      background: "linear-gradient(to bottom, hsla(0, 0%, 5%, 0.5) 0%, hsla(0, 0%, 5%, 0.6) 50%, hsla(0, 0%, 5%, 0.78) 100%)"
    }} />

      {}
      <div className={`absolute top-8 right-6 md:top-10 md:right-12 z-20 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
        <div className="flex items-center gap-2 px-3 py-1.5 backdrop-blur-sm border rounded-md" style={{
        backgroundColor: "var(--card)",
        borderColor: "var(--accent)"
      }}>
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-md opacity-75 animate-ping" style={{
            backgroundColor: "var(--accent)"
          }} />
            <span className="relative inline-flex rounded-md h-2 w-2" style={{
            backgroundColor: "var(--accent)"
          }} />
          </span>
          <span className="text-[11px] font-mono tracking-widest uppercase" style={{
          color: "var(--accent)"
        }}>
            Now Booking 2025
          </span>
        </div>
      </div>

      {}
      <div className="relative z-10 w-full h-full max-w-[1440px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-20 md:pb-28">
        <div ref={contentRef} className={`max-w-4xl transition-all duration-1200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex items-center gap-4 mb-8 md:mb-10">
            <span className="text-[11px] md:text-xs font-mono tracking-[0.3em] uppercase" style={{
            color: "var(--accent)"
          }}>
              Oddhatter — Digital Playground
            </span>
            <div className="hidden sm:block h-px w-[60px]" style={{
            backgroundColor: "var(--accent)"
          }} />
          </div>

          {}
          <h1 className="font-default font-bold leading-[0.95] mb-8 md:mb-10" style={{
          fontSize: "clamp(3rem, 8vw, 7.5rem)",
          color: "var(--foreground)"
        }}>
            <span className="block">Where chaos</span>
            <span className="block italic" style={{
            color: "var(--accent)"
          }}>
              finds its rhythm.
            </span>
          </h1>

          {}
          <p className="font-default text-base md:text-[17px] leading-relaxed mb-10 md:mb-12 max-w-[480px]" style={{
          color: "var(--muted-foreground)"
        }}>
            High-energy entertainment, stand-up comedy, and digital absurdity hosted by the one and only Oddhatter.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
            <Button asChild size="lg" className="h-12 px-8 text-sm font-medium tracking-wider uppercase rounded-md border-2 border-ghost-text" style={{
            backgroundColor: "var(--background)",
            color: "white"
          }}>
              <Link to="/TheOddhatterShowPage">Dive In</Link>
            </Button>

            <Link to="/TheOddhatterShowPage" className="group inline-flex items-center gap-2.5 text-sm font-medium tracking-wider uppercase transition-colors" style={{
            color: "var(--foreground)"
          }}>
              <PlayCircle className="w-5 h-5 transition-transform group-hover:scale-110" style={{
              color: "var(--accent)"
            }} />
              <span className="relative">
                Watch Showreel
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100" style={{
                backgroundColor: "var(--accent)"
              }} />
              </span>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className={`absolute bottom-12 right-8 md:right-12 z-10 hidden md:flex flex-col items-center gap-4 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <span className="text-[10px] font-mono tracking-[0.4em] uppercase" style={{
        color: "var(--muted-foreground)",
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          Scroll
        </span>
        <div className="relative h-20 w-px overflow-hidden">
          <div className="absolute inset-0 w-px" style={{
          backgroundColor: "var(--muted-foreground)"
        }} />
          <div className="absolute top-0 left-0 w-px h-8 animate-[scroll-line_2s_ease-in-out_infinite]" style={{
          backgroundColor: "var(--accent)"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes slow-zoom {
          0% { transform: scale(1.1); }
          100% { transform: scale(1.0); }
        }
        @keyframes scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}